import Icon from 'veui/components/Icon'
import { IconCaretDown } from 'dls-icons-vue'

Icon.register('caret-down', IconCaretDown)
